import * as _ from 'lodash';
import fetchMg from '../utilities/fetchManager';
import { messageUtility } from '../utilities/messageUtility';
import { requestWithToken } from '../utilities/request';

/**
 * 現場情報
 * @param {int} field_id
 */
export const FieldData = async field_id => {
  return await fetchMg
    .GetAjax(`/api/private/fields/${field_id}`, {})
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/**
 * プロフィール
 */
export const UserProfile = async () => {
  console.log('debug', 'src/services/FieldTree.js UserProfile');
  return await fetchMg
    .GetAjax(`/api/private/user_profiles`, {})
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/*
 * 元請情報
 *
 */
export const ConstructorData = async () => {
  return await fetchMg
    .GetAjax(`/api/private/company_branches/prime_list`, {})
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/**
 * JV情報
 * https://v2-dev.buildee.jp/apidocs/public/company_branches/jv_company_list.html
 * /api/private/fields/:field_id/jv_company_list
 *
 */
export const JVListsData = async field_id => {
  return await fetchMg
    .GetAjax(`/api/private/fields/${field_id}/jv_company_list`, {})
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/**
 * 体系図一覧
 * @param {int} field_id
 * @param {object} params
 */
export const FieldTreeList = async (field_id, params) => {
  return await fetchMg
    .GetAjax(`/api/private/fields/${field_id}/field_trees/list`, params)
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/**
 * 体系図一覧
 * @param {int} field_id
 * @param {object} params
 */
export const FieldTreeListLevel = async (field_id, params) => {
  return await fetchMg
    .GetAjax(
      `/api/private/fields/${field_id}/field_trees/${params.field_tree_id}`,
      params
    )
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/**
 * 体系図会社詳細
 * api :GET, '/api/private/fields/:field_id/field_trees/:id'
 * 現場ツリー情報取得API
 * @param {int} field_id
 * @param {object} params
 */
export const FieldTree = async (field_tree_id, field_id, params) => {
  return await fetchMg
    .GetAjax(
      `/api/private/fields/${field_id}/field_trees/${field_tree_id}`,
      params
    )
    .then(async result => {
      return {
        entities: _.cloneDeep(result.data.entities),
        // 何次請か(1開始)
        login_user_tree_nest_no: result.data.login_user_tree_nest_no,
        // 配下かどうか
        is_subordinate: result.data.is_subordinate,
      };
    })
    .catch(async () => {
      return null;
    });
};

/**
 * 役職一覧
 * /api/private/company_branches/:company_branch_id/positions/list
 */
export const PositionList = async (
  company_branch_id,
  display_flag,
  no_limit_flag
) => {
  return await fetchMg
    .GetAjax(`/api/private/positions/list`, {
      company_branch_id,
      display_flag,
      no_limit_flag,
    })
    .then(async data => {
      return _.cloneDeep(data.data.entities);
    })
    .catch(async () => {
      return null;
    });
};

/**
 * JV一覧
 * https://v2-dev.buildee.jp/apidocs/public/company_branches/jv_company_list.html
 * api/private/fields/:field_id/jv_company_list
 * @param {*} fieldId
 */
export const JVList = async field_id => {
  return await fetchMg
    .GetAjax(`/api/private/fields/${field_id}/jv_company_list`, {})
    .then(async data => {
      return _.cloneDeep(data.data.entities);
    })
    .catch(async () => {
      return null;
    });
};

/**
 * 会社情報
 * https://v2-dev.buildee.jp/apidocs/public/field_trees/show.html
 * /api/private/field_trees/:id
 */
export const FieldCompany = async company_branch_id => {
  return await fetchMg
    .GetAjax(`/api/private/field_trees/${company_branch_id}`, {})
    .then(async data => {
      return _.cloneDeep(data.data.entities);
    })
    .catch(async () => {
      return null;
    });
};

/**
 *
 * グループ新規作成
 * @param {int} field_id
 * @param {object} param
 */
export const NewGroupAdd = async (field_id, param) => {
  return await fetchMg
    .PostAjax(`/api/private/fields/${field_id}/field_groups`, param)
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/**
 *
 * 協力会社ユーザー管理者招待
 * @param {int} field_id
 * @param {object} param
 */
export const PartnerUserInvite = async (field_id, field_tree_id, param) => {
  return await fetchMg
    .PostAjax(
      `/api/private/fields/${field_id}/field_trees/${field_tree_id}/field_tree_users`,
      param
    )
    .then(async data => {
      return { result: _.cloneDeep(data.data) };
    })
    .catch(async error => {
      let message;
      if (error && error.length > 0) {
        message = error[0].responseJSON.message;
      } else {
        // errorに入ってないときは安全にデフォルトのエラーメッセージ
        message = messageUtility.getMessage('E-000-001');
      }
      return { message };
    });
};

/**
 *
 * https://v2-dev.buildee.jp/apidocs/public/field_tree_users/destroy_list.html
 * /api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users/list
 * ユーザー削除
 * @param {int} field_id
 * @param {object} param
 */
export const PartnerUserDelete = async (field_id, field_tree_id, param) => {
  return await fetchMg
    .DeleteAjax(
      `/api/private/fields/${field_id}/field_trees/${field_tree_id}/field_tree_users/list`,
      param
    )
    .then(async data => {
      return _.cloneDeep(data);
    })
    .catch(async e => {
      const response = _.has(e[0], 'responseJSON')
        ? e[0].responseJSON
        : { message: '' };
      return response;
    });
};

/**
 *
 * https://v2-dev.buildee.jp/apidocs/public/field_trees/invite.html
 * /api/private/fields/:field_id/field_trees/invite
 * 協力会社招待
 * @param {int} field_id
 * @param {object} param
 */
export const PartnerCompanyInvite = async (field_id, param) => {
  return await fetchMg
    .PostAjax(`/api/private/fields/${field_id}/field_trees/invite`, param)
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async e => {
      return { error: e };
    });
};

/**
 * マスター協力会社
 * @param {}} props
 * https://v2-dev.buildee.jp/apidocs/public/companies.html
 * /api/private/companies/:id
 */
export const MasterCompany = async param => {
  return await fetchMg
    .GetAjax(`/api/private/companies/${param.id}`, {})
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/**
 *
 * 協力会社
 * https://v2-dev.buildee.jp/apidocs/public/company_branches/company_partner.html
 * api/private/company_branches/company_partner/
 * @param {*} param
 */
export const BranchCompany = async param => {
  return await fetchMg
    .GetAjax(`/api/private/company_branches/company_partner/${param.id}`, param)
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/**
 * マスターグループ一覧
 * @param {number} field_id
 * api/private/fields/:field_id/field_groups/list?limit=:limit¥&offset=:offset¥&columns=:columns¥&order=:order
 * `/api/private/fields/:field_id/field_groups/list
 */
export const MasterGroups = async field_id => {
  return await fetchMg
    .GetAjax(`/api/private/fields/${field_id}/field_groups/list`, {})
    .then(async data => {
      return _.cloneDeep(data.data);
    })
    .catch(async () => {
      return null;
    });
};

/**
 * CCUS現場取得開始API
 * @param {number} field_id
 * */
export const fetchCcusFieldTreeState = field_id => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/ccus/fields/${field_id}/ccus_field_tree_state_managements`,
  });
};

/**
 * CCUS施工体制登録API
 * @param {number} field_id
 * */
export const ccusFieldTree = field_id => {
  return requestWithToken({
    method: 'POST',
    url: `/api/private/ccus/field_tree`,
    data: { field_id },
  });
};

/**
 * CCUS施工体系自動連携再開API
 * @param {number} field_id
 * */
export const ccusFieldTreeStart = field_id => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/ccus/field_tree_auto_task/active`,
    data: { field_id },
  });
};

/**
 * CCUS施工体系自動連携停止API
 * @param {number} field_id
 * */
export const ccusFieldTreeStop = field_id => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/ccus/field_tree_auto_task/inactive`,
    data: { field_id },
  });
};

export const jvCompanyList = (field_id, params) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/fields/${field_id}/jv_company_list`,
    params,
  });
};

export const checkPartnerReportsCreated = (field_id, field_tree_id) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/fields/${field_id}/field_trees/${field_tree_id}/check_partner_reports_created`,
  });
};

export const updateFieldTreeList = (fieldId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/fields/${fieldId}/field_trees/list`,
    data,
  });
};

export const updateFinishFlagFieldTree = (fieldId, fieldTreeId, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/fields/${fieldId}/field_trees/${fieldTreeId}/finish_flag`,
    data,
  });
};



// WEBPACK FOOTER //
// ./src/services/FieldTree.js